import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const NewFiles: FC<ISvG> = ({
  width = "16",
  height = "16",
  fill = "#858e95",
  customClassName,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14.916 19.889"
      className={customClassName}
    >
      <path
        d="M133.243-176.112A1.244,1.244,0,0,1,132-177.356v-17.4A1.244,1.244,0,0,1,133.243-196H140.7v4.972a1.244,1.244,0,0,0,1.243,1.244h4.972v12.429a1.244,1.244,0,0,1-1.243,1.244Zm8.7-14.916V-196l4.973,4.972Z"
        transform="translate(-132 196)"
        fill={fill}
      />
    </svg>
  );
};

export default memo(NewFiles);
